module.exports = __webpack_public_path__ + "static/media/pattern-shake.81d1e49b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-shake.svg
// module id = 1269
// module chunks = 37